import {type Thumbnails} from '../MediaCard';

export type MediaSize = {width: number; height: number};

type MediaSizeSources = {
  isSprite: boolean;
  thumbnails: Thumbnails | undefined;
  naturalDimensions: MediaSize | null;
  mediaWidth: number | undefined;
  mediaHeight: number | undefined;
};

function isValidDimension(value: number | undefined): value is number {
  return value != null && Number.isFinite(value) && value > 0;
}

/**
 * Picks the most accurate known size of one image: the server's original size,
 * then the decoded size, then history. History records one size per step, so it
 * is wrong for later images in a mixed-size list; it is only a fallback for
 * single images. Thumbnail and decoded sizes describe a whole sprite sheet, so
 * sprites always use the history frame size.
 */
export function resolveMediaSize({
  isSprite,
  thumbnails,
  naturalDimensions,
  mediaWidth,
  mediaHeight,
}: MediaSizeSources): MediaSize | null {
  if (!isSprite) {
    const thumbnail = thumbnails?.[0];
    if (
      thumbnail != null &&
      thumbnail.originalImageWidth > 0 &&
      thumbnail.originalImageHeight > 0
    ) {
      return {
        width: thumbnail.originalImageWidth,
        height: thumbnail.originalImageHeight,
      };
    }
    if (naturalDimensions != null) {
      return naturalDimensions;
    }
  }
  if (isValidDimension(mediaWidth) && isValidDimension(mediaHeight)) {
    return {width: mediaWidth, height: mediaHeight};
  }
  return null;
}
